import React from "react";

export default function Modal({ children, closeModal, isOpen, title }) {
	if (!isOpen) return null;

	return (
		<div className="modal is-active">
			<div className="modal-background" onClick={closeModal} />
			<div className="modal-card">
				<header className="modal-card-head">
					<p className="modal-card-title">{title}</p>
					<button type="button" className="delete" onClick={closeModal} />
				</header>
				<section className="modal-card-body">
					<div className="content">{children}</div>
				</section>
			</div>
		</div>
	);
}
